import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FramingBand } from '../components/FramingBand';
import { ProblemSection } from '../components/ProblemSection';
import { PlatformOverview } from '../components/PlatformOverview';
import { OperatingModel } from '../components/OperatingModel';
import { CapabilityDomains } from '../components/CapabilityDomains';
import { HumanOpportunity } from '../components/HumanOpportunity';
import { LifecycleArchitecture } from '../components/LifecycleArchitecture';
import { Solutions } from '../components/Solutions';
import { ProductEcosystem } from '../components/ProductEcosystem';
import { GlobalArchitecture } from '../components/GlobalArchitecture';
import { LeadershipReadiness } from '../components/LeadershipReadiness';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { RelatedInitiative } from '../components/initiatives/RelatedInitiative';
import { HumanCapabilityModels } from '../components/HumanCapabilityModels';
export function HumanCapabilityPage() {
  return <>
      <HeroSection data-id="element-1733" data-mp="3k524pl9s6tzs" />
      <FramingBand data-id="element-1734" data-mp="3k4ai2zy5w6ln" />
      <HumanCapabilityModels data-id="element-1735" data-mp="3k5vc8ogkdniz" />
      <ProblemSection data-id="element-1736" data-mp="3k2zfh3ggd4w4" />
      <PlatformOverview data-id="element-1737" data-mp="3p4f04uepx9dz" />
      <OperatingModel data-id="element-1738" data-mp="3p3ws70ip16q8" />
      <CapabilityDomains data-id="element-1739" data-mp="3p2lsbbsdcj4e" />
      <HumanOpportunity data-id="element-1740" data-mp="3p2bzzhjupzvj" />
      <LifecycleArchitecture data-id="element-1741" data-mp="3tuloct5birvp" />
      <Solutions data-id="element-1742" data-mp="3tvwxz9lg2tuq" />
      <ProductEcosystem data-id="element-1743" data-mp="3twgaubw8ms1w" />
      <RelatedInitiative name="Cognocracy" status="Concept Proposal" body="Explore a proposed civic application of the Human Capability Framework and NCJI." href="/projects/cognocracy" data-id="element-1744" data-mp="3twq202t0r596" />
      <GlobalArchitecture data-id="element-1745" data-mp="boqt4d4ixace" />
      <LeadershipReadiness data-id="element-1746" data-mp="bqk0jumynylg" />
      <FAQ data-id="element-1747" data-mp="bn5xsladxndh" />
      <FinalCTA data-id="element-1748" data-mp="bnfq4fiwk6mc" />
    </>;
}